import React from "react";
import InputDatoProdotto from "../elementiPagina/InputDatoProdotto";
import InputTendinaDatoProdotto from "../elementiPagina/InputTendinaDatoProdotto";
import InputColore from "../elementiPagina/InputColore";
import AreaInputColore from "../elementiPagina/AreaInputColore";
import InputDatoProdottoNumero from "../InputDatoProdottoNumero";
import InputSciancratura from "../elementiPagina/InputSciancratura";
import { publicationSelectionFromValue } from "../../moda/publicationStatus";

const SITE_LABELS = { VIG: "Viglietti", BOT: "Bottero" };

function OnlineFeatureReference({ prestashopOnline, tab, field, visible = true }) {
    if (!visible) return null;
    const references = Object.entries(prestashopOnline?.sites || {}).map(([site, data]) => {
        const values = data?.features?.[tab + "." + field]?.values || [];
        const text = values.map((item) => item.value).filter(Boolean).join(" / ");
        return text ? (SITE_LABELS[site] || site) + ": " + text : null;
    }).filter(Boolean);
    if (!references.length) return null;
    return <div className="f7 gray mt1 mb2">Online — {references.join(" · ")}</div>;
}

function DatiUlteriori({
    prodottoTemp,
    tab,
    datiUlterioriTab,
    datoOnChange,
    inputClasses,
    colSelChange,
    colNonSelChange,
    handleChangeSciancratura,
    arrayTipoDatiPermessi,
    prestashopOnline,
    showOnlineFeatureReferences,
    avvisoSpedizione
}) {


    const gruppiDatiUlteriori =
        datiUlterioriTab && typeof datiUlterioriTab === "object"
            ? datiUlterioriTab
            : {};

    return (
        <div>
            {Object.keys(gruppiDatiUlteriori).map((val, i) => {

                const gruppo = gruppiDatiUlteriori[val];

                if (!arrayTipoDatiPermessi || arrayTipoDatiPermessi.includes(gruppo.tipo)) {
                    let valore;
                    let cosaUso;

                    if (gruppo.pathAlternativo) {
                        // qui in un prossimo futuro userò il dato del path alternativo per fare la query dell'oggetto
                        if (val === "codiceProduttore" && prodottoTemp && prodottoTemp.codiceProduttore && prodottoTemp.codiceProduttore.codProduttoreIntero) {
                            cosaUso = "1";
                            valore = prodottoTemp.codiceProduttore.codProduttoreIntero;
                        } else if (val === "shortName" && prodottoTemp.shortName && prodottoTemp.shortName.it) {
                            cosaUso = "2";
                            valore = prodottoTemp.shortName.it;
                        } else {
                            cosaUso = "3";
                            valore = ""
                        }
                    } else if ( //QUESTO PUO' DI SICURO ESSERE SCRITTO IN MODO PIU' FURBO
                        prodottoTemp["datiUlteriori"]
                        && prodottoTemp["datiUlteriori"][tab]
                        && prodottoTemp["datiUlteriori"][tab][val]
                        && prodottoTemp["datiUlteriori"][tab][val]["valueId"]
                    ) {
                        cosaUso = "4";
                        valore = prodottoTemp["datiUlteriori"][tab][val]["valueId"]
                    } else if (
                        prodottoTemp["datiUlteriori"]
                        && prodottoTemp["datiUlteriori"][tab]
                        && prodottoTemp["datiUlteriori"][tab][val]
                        && prodottoTemp["datiUlteriori"][tab][val]["valueDesc"]

                    ) {
                        cosaUso = "5";
                        valore = prodottoTemp["datiUlteriori"][tab][val]["valueDesc"]
                    } else {
                        //console.log('prodottoTemp["datiUlteriori"][tab][val]', prodottoTemp["datiUlteriori"][tab][val])
                        //console.log("tab", tab)
                        //console.log("val",val)
                        cosaUso = "6";
                        valore = ""
                    }
                    if (tab === "web" && val === "pubblicato") {
                        valore = publicationSelectionFromValue(prodottoTemp?.datiUlteriori?.web?.pubblicato);
                    }
                    /* return(
                        
                        <pre>{JSON.stringify(gruppo, null, 2)}</pre>
                    ) */

                    if (gruppo.tipo === "Testo") {
                        return (
                            <>
                            <InputDatoProdotto
                                inputLabel={gruppo.label}
                                datoName={gruppo.pathObjProd}
                                datoId={gruppo.label + "id"}
                                datoValue={valore ?? ""}
                                datoPlaceHolder=""
                                datoOnChange={datoOnChange}
                                datoClass={inputClasses}
                                classiTastoSblocco="dn" //questo nasconde il tasto copia
                                tastoCopiaAspetto="" //altrimenti {tastoCopiaAspetto}
                                cosaUso={cosaUso + " " + tab + " " + val}
                                tastiPredefiniti={gruppo.tastiPredefiniti ?? false}
                                tooltip={gruppo.tooltip}
                            />
                            <OnlineFeatureReference prestashopOnline={prestashopOnline} tab={tab} field={val} visible={showOnlineFeatureReferences} />
                            </>
                        )
                    } else if (gruppo.tipo === "Numero") {
                        return (
                            <>
                            <InputDatoProdottoNumero
                                inputLabel={gruppo.label}
                                datoName={gruppo.pathObjProd}
                                datoId={gruppo.label + "id"}
                                datoValue={valore ?? ""}
                                datoPlaceHolder=""
                                datoOnChange={datoOnChange}
                                datoClass={inputClasses}
                                classiTastoSblocco="dn" //questo nasconde il tasto copia
                                tastoCopiaAspetto="" //altrimenti {tastoCopiaAspetto}
                                cosaUso={cosaUso + " " + tab + " " + val}
                                tooltip={gruppo.tooltip}
                            />
                            <OnlineFeatureReference prestashopOnline={prestashopOnline} tab={tab} field={val} visible={showOnlineFeatureReferences} />
                            </>
                        )
                    } else if (gruppo.tipo === "Sciancratura") {
                        return (
                            <>
                            <InputSciancratura
                                inputLabel={gruppo.label}
                                datoName={gruppo.pathObjProd}
                                datoId={gruppo.label + "id"}
                                datoValue={valore ?? ""}
                                datoPlaceHolder=""
                                datoOnChange={datoOnChange}
                                handleChangeSciancratura={handleChangeSciancratura}
                                datoClass={inputClasses}
                                classiTastoSblocco="dn" //questo nasconde il tasto copia
                                tastoCopiaAspetto="" //altrimenti {tastoCopiaAspetto}
                                cosaUso={cosaUso + " " + tab + " " + val}
                            />
                            <OnlineFeatureReference prestashopOnline={prestashopOnline} tab={tab} field={val} visible={showOnlineFeatureReferences} />
                            </>
                        )
                    } else if (gruppo.tipo === "Tendina") {
                        /* console.log("tend", gruppo.label,"valore",valore,"gruppo.dati",gruppo.dati)
                        let datoSelezionato = gruppo.dati.filter(dato => dato.idPS === valore && valore !== "");
                        let altriDati = gruppo.dati.filter(dato => dato.idPS !== valore || valore === "") */

                        return (
                            <>
                            <InputTendinaDatoProdotto
                                objOpzioni={gruppo.dati}
                                //datoSelezionato={datoSelezionato}
                                //altriDati={altriDati}
                                datoValue={valore}
                                inputLabel={gruppo.label}
                                datoName={gruppo.pathObjProd}
                                datoId={gruppo.label + "id"}
                                datoOnChange={datoOnChange}
                                datoClass={inputClasses}
                            //cosaUso={cosaUso + " " + tab + " " + val}
                            />
                            {tab === "web" && avvisoSpedizione?.campo === val && (
                                <p className="dark-red f7">{avvisoSpedizione.testo}</p>
                            )}
                            <OnlineFeatureReference prestashopOnline={prestashopOnline} tab={tab} field={val} visible={showOnlineFeatureReferences} />
                            </>
                        )
                    } else if (gruppo.tipo === "Colore") {

                        return (
                            <>
                            <InputColore
                                objOpzioni={gruppo.dati}
                                datoValue={valore}
                                inputLabel={gruppo.label}
                                datoName={gruppo.pathObjProd}
                                datoId={gruppo.label + "id"}
                                datoOnChange={datoOnChange}
                                datoClass={inputClasses}
                            />
                            <OnlineFeatureReference prestashopOnline={prestashopOnline} tab={tab} field={val} visible={showOnlineFeatureReferences} />
                            </>
                        )
                    } else if (gruppo.tipo === "ColoriInsieme") {
                        return (
                            <>
                            <AreaInputColore
                                colori={gruppo.dati}
                                inputLabel={gruppo.label}
                                datoId={gruppo.label + "id"}
                                colSelChange={colSelChange}
                                colNonSelChange={colNonSelChange}
                                col1={prodottoTemp.datiUlteriori?.generici?.colore1 ?? ""}
                                col2={prodottoTemp.datiUlteriori?.generici?.colore2 ?? ""}
                                col3={prodottoTemp.datiUlteriori?.generici?.colore3 ?? ""}
                            />
                            <OnlineFeatureReference prestashopOnline={prestashopOnline} tab={tab} field={val} visible={showOnlineFeatureReferences} />
                            </>
                        )
                    } else {
                        return <div><p>{gruppo.label} - {gruppo.tipo}</p>
                            <p>{gruppo.pathObjProd}</p>
                        </div>
                    }
                }

                return null;


            })}
        </div>
    )



}

export default DatiUlteriori;
